import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FieldArray } from 'react-final-form-arrays';
import { useForm } from 'react-final-form';
import AddDeleteButtons from 'src/common/form/AddDeleteButtons/AddDeleteButtons';
import { defaultPaymentsInsurance } from 'src/components/Insurance/utils/';
import PaymentsInsuranceFieldsContainer from 'src/components/Insurance/PaymentsInsuranceFieldsContainer';
import '../Intake/stylesheets/intake.scss';

class PaymentsInformation extends Component {
  static customHideRemoveButton() {
    return false;
  }

  static onAddPaymentsInsuranceFields(fields) {
    const newPaymentsFormId = defaultPaymentsInsurance();
    const newIndex = fields.length;
    fields.push(newPaymentsFormId);

    setTimeout(() => {
      const newPlanTypeSelect = document.getElementById(`insurance-plan-type-${newIndex}`);
      if (newPlanTypeSelect) {
        const focusable = newPlanTypeSelect.querySelector('input, [tabindex]') || newPlanTypeSelect;
        focusable.focus();
      }
    }, 200);
  }

  constructor(props) {
    super(props);

    this.renderInsuranceFields = this.renderInsuranceFields.bind(this);
    this.renderSingleInsuranceField = this.renderSingleInsuranceField.bind(this);
  }

  renderSingleInsuranceField(name, index, fields) {
    const {
 contactId, intake, multi, form,
} = this.props;
    const namespace = 'insurance-form-button';
    const classes = classnames(namespace, intake && `${namespace}--intake`);
    const formId = fields.value?.[index]?.form_id;

    return (
      <div className="insurance-form-head" key={formId || `insurance-${index}`}>
        <PaymentsInsuranceFieldsContainer
          contactId={contactId}
          fieldPrefix={name}
          index={index}
          form={form}
        />
        {intake && (<div className="payments-insurance-divider" />)}
        {index !== 0 && multi && (
          <div className={classes}>
            <AddDeleteButtons
              displayText="Delete Insurance"
              onRemoveClick={() => fields.remove(index)}
            />
          </div>
        )}
        {!intake && (<div className="payments-insurance-client-divider" />)}
      </div>
    );
  }

  renderInsuranceFields({ fields }) {
    const { intake, multi } = this.props;
    const footer = 'insurance-form-button-footer h-10';
    const footerClasses = classnames(footer, intake && `${footer}--intake`);

    return (
      <div className="payments-insurance__information">
        <div className="flex">
          <div className="w-full -mr-32">
            {fields.map((name, index) => this.renderSingleInsuranceField(name, index, fields))}
          </div>
          {multi && (
            <div className={footerClasses}>
              <AddDeleteButtons
                displayText="Add Insurance"
                onAddClick={() => PaymentsInformation.onAddPaymentsInsuranceFields(fields)}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    return (
      <FieldArray name="insurance">
        {this.renderInsuranceFields}
      </FieldArray>
    );
  }
}

PaymentsInformation.propTypes = {
  contactId: PropTypes.string,
  form: PropTypes.object.isRequired,
  intake: PropTypes.bool,
  multi: PropTypes.bool,
};

PaymentsInformation.defaultProps = {
  contactId: '',
  intake: false,
  multi: true,
};

// Wrapper component to inject form from context
const PaymentsInformationWrapper = (props) => {
  const form = useForm();
  return <PaymentsInformation {...props} form={form} />;
};

PaymentsInformationWrapper.propTypes = {
  contactId: PropTypes.string,
  intake: PropTypes.bool,
  multi: PropTypes.bool,
};

PaymentsInformationWrapper.defaultProps = {
  contactId: '',
  intake: false,
  multi: true,
};

PaymentsInformationWrapper.navigation = [
  {
    id: 'insurance-information',
    name: 'Insurance Information',
    standard: true,
  },
];

export default PaymentsInformationWrapper;
